import { z } from 'zod/mini'

import { checkoutItemSchema } from './cart-item'
import { gtmMetadataShape } from './gtm-metadata'
import { nonEmptyString } from './non-empty-string'
import { requireItemsUnlessTradeInOnly } from './require-items-unless-trade-in-only'
import { tradeInDetailsSchema } from './trade-in-details'

export const beginCheckoutSchema = z
  .strictObject({
    ...gtmMetadataShape,
    event: z.literal('begin_checkout'),
    has_trade_in: z.boolean(),
    ecommerce: z.strictObject({
      currency: nonEmptyString(),
      value: z.number().check(z.gte(0)),
      items: z.array(checkoutItemSchema),
    }),
    trade_in_details: z.optional(tradeInDetailsSchema),
  })
  .check(requireItemsUnlessTradeInOnly())
